var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoverageFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#F4F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_367_5710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5755 19.2221L10.4717 21.7315V11.6938C10.4717 11.5274 10.5378 11.3678 10.6554 11.2502C10.7731 11.1325 10.9327 11.0664 11.099 11.0664H21.1368C21.3032 11.0664 21.4628 11.1325 21.5804 11.2502C21.6981 11.3678 21.7642 11.5274 21.7642 11.6938V18.5947C21.7642 18.7611 21.6981 18.9207 21.5804 19.0383C21.4628 19.156 21.3032 19.2221 21.1368 19.2221H13.5755Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2363 19.2196V22.3564C14.2363 22.5228 14.3024 22.6824 14.4201 22.8001C14.5377 22.9177 14.6973 22.9838 14.8637 22.9838H22.4249L25.5288 25.4932V15.4555C25.5288 15.2891 25.4627 15.1295 25.3451 15.0119C25.2274 14.8942 25.0678 14.8281 24.9014 14.8281H21.7646",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_5710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageFrame);
export default __webpack_public_path__ + "static/media/coverage-frame.73ac4932.svg";
export { ForwardRef as ReactComponent };